import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { coverageTaxServiceConfigSchema } from '../configurations/CoverageTaxServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderCoverageTaxDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.COVERAGE_TAX]: coverageTaxServiceConfigSchema,
    }),
});

export { servicesProviderCoverageTaxDataSchema };
//# sourceMappingURL=ServicesProviderCoverageTaxData.js.map
